var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgLogoutIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.777 11.55-2.3 2.29a.999.999 0 0 0 0 1.42 1.001 1.001 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76.999.999 0 0 0-.21-.33l-4-4a1.004 1.004 0 1 0-1.42 1.42l2.3 2.29h-9.59a1 1 0 0 0 0 2h9.59Zm-.59-11a10 10 0 0 0-9 5.55 1.006 1.006 0 0 0 1.8.9 8 8 0 1 1 7.2 11.55 7.93 7.93 0 0 1-7.16-4.45 1.006 1.006 0 0 0-1.8.9A10 10 0 1 0 10.187.55Z",
    fill: "#2E2E2E"
  })));
};
export { SvgLogoutIcon as ReactComponent };
export default __webpack_public_path__ + "4e11653a27bec6c5bf645613b451a5d5.svg";